import React, { useEffect, useRef, useState } from 'react'
import { getLocations } from '../../services/userservice';
import { bulkSave } from '../../services/bookingservice';
import { hasDuplicates } from '../../utils/util';
import { getSession } from '../../global';
import { useSelector, useDispatch } from 'react-redux';
import { setLoading } from '../../redux/appSlice';
import { setData, setFileLen, setFileType, setGrid, setGridStatus, setFileName } from '../../redux/darazBulkBookingSlice';
const Form = ({ myWorker }) => {
    const dispatch = useDispatch();
    const state = useSelector(state => { return { appData: state.appData, darazBulkBookingData: state.darazBulkBookingData } });
    const { destinations, loading, userInfo, types, subaccounts } = state.appData;
    const {
        data,
        fileLen,
        fileType,
        fileName,
        grid } = state.darazBulkBookingData;

    const dests = destinations.map(x => x.text);

    const [locations, setLocations] = useState([]);

    const updateData = (key, val) => {
        const d = { ...data, [key]: val };
        dispatch(setData({ data: d }));
    };

    const fileRef = useRef(null);

    useEffect(() => {
        myWorker.onmessage = function (event) {
            fileRef.current.value = null;
            dispatch(setFileLen({ data: 0 }));
            dispatch(setFileName({ data: '' }));
            const { sts, msg, dt } = event.data;
            if (sts === 0) {
                dispatch(setGrid({ data: dt }));
            } else {
                alert(msg);
            }
            //dispatch(setLoading({ data: false }));
        }
    }, [])

    const onUpload = async () => {
        //dispatch(setLoading({ data: true }));
        const file = fileRef.current.files[0];
        const type = 0;
        myWorker.postMessage({ file: file, type: type, destinations: destinations });
    }

    const validateExcel = () => {

        if (!data.subAccountId) {
            alert('Select Sub Account');
            return false;
        }

        if (!data.locationId) {
            alert('Select Location');
            return false;
        }

        if (grid.filter(x => !x.ConsignmentNo).length > 0) {
            alert('Consignment No is required');
            return false;
        } else {
            const cns = grid.map(x => x.ConsignmentNo);
            if (hasDuplicates(cns)) {
                alert('Duplicate Consignment No are not allowed');
                return false;
            } else {
                const sequnce = getSession('sequences').filter(x => x.locationId == data.locationId)[0];
                const start = Number(sequnce.sequenceStart);
                const end = Number(sequnce.sequenceEnd);
                for (const x of grid) {
                    let num = Number(x.ConsignmentNo);
                    if (!(num >= start && num <= end)) {
                        alert(`Invalid Consignment# ${num}`);
                        return false;
                    }
                }
            }
        }


        if (grid.filter(x => !x.ConsigneeName || x.ConsigneeName.trim() == '').length > 0) {
            alert('Consignee Name is required');
            return false;
        }

        if (grid.filter(x => !x.ConsigneeAddress || x.ConsigneeAddress.trim() == '').length > 0) {
            alert('Consignee Address is required');
            return false;
        }

        if (grid.filter(x => !x.DestinationCity || !dests.map(y => y.toUpperCase()).includes(x.DestinationCity.toUpperCase())).length > 0) {
            alert('Destination is required');
            return false;
        }

        if (grid.filter(x => !x.Pieces || x.Pieces <= 0).length > 0) {
            alert('Pieces is required');
            return false;
        } else {
            if (grid.filter(x => x.Pieces > 99).length > 0) {
                alert('Pieces must be less than or equals to 99');
                return false;
            }
        }

        if (grid.filter(x => !x.Weight || x.Weight <= 0).length > 0) {
            alert('Weight is required');
            return false;
        } else {
            const w = data.isCod ? 99 : 9999;
            if (grid.filter(x => x.Weight > w).length > 0) {
                alert('Weight must be less than or equals to ' + w);
                return false;
            }
        }

        if (data.isCod) {

            if (!userInfo.isZeroCodAllowed) {
                if (grid.filter(x => x.CODAmount.trim() == '' || x.CODAmount <= 0).length > 0) {
                    alert('0 Cod amount not allowed');
                    return false;
                }
            }

            if (grid.filter(x => x.CODAmount.trim() > 99999).length > 0) {
                alert('COD amount must be less than or equals to 99999');
                return false;
            }

            if (grid.filter(x => !x.CustomerReferenceNumber || x.CustomerReferenceNumber.trim() == '').length > 0) {
                alert('Customer Reference Number not found');
                return false;
            }
        }

        if (!userInfo.isDuplicateOrderAllowed) {
            const refno = grid.filter(x => x.CustomerReferenceNumber && x.CustomerReferenceNumber.trim() != '').map((x, index) => x.CustomerReferenceNumber);
            if (hasDuplicates(refno)) {
                alert('Duplicate CustomerReferenceNumber not allowed');
                return false;
            }
        }

        if (grid.filter(x => !x.ServiceType || !['Overnight'.toUpperCase(), 'Second Day'.toUpperCase(), 'Express Cargo'.toUpperCase()].includes(x.ServiceType.toUpperCase())).length > 0) {
            alert('Service Type is required');
            return false;
        }


        if (grid.filter(x => x.DRTV.toUpperCase() == 'YES' && (
            (!x.SupplierName || x.SupplierName.trim() == '') ||
            (!x.SupplierAddress || x.SupplierAddress.trim() == '') ||
            (!x.SupplierBranch || x.SupplierBranch.trim() == '') ||
            (!x.SupplierPhone || x.SupplierPhone.trim() == '')
        )).length > 0) {
            alert('Supplier info is required');
            return false;
        }

        if (grid.filter(x => x.SupplierBranch && !dests.map(y => y.toUpperCase()).includes(x.SupplierBranch.toUpperCase())).length > 0) {
            alert('Supplier Branch is invalid');
            return false;
        }

        return true;
    }

    const onSave = async () => {
        if (validateExcel()) {
            //return;
            var d = {
                user: {
                    id: userInfo.id,
                    isDuplicateOrderAllowed: userInfo.isDuplicateOrderAllowed
                },
                accountNo: data.accountNo,
                locationId: Number(data.locationId),
                subAccountId: Number(data.subAccountId),
                autoCN: data.autoCN,
                bookings: grid.map(y => {
                    return {
                        cn: y.ConsignmentNo,
                        bookingDate: y.BookingDate,
                        cnType: y.SpecialHandling == 'yes' ? 13 : 12,
                        consignee: y.ConsigneeName,
                        consigneeAddress: y.ConsigneeAddress,
                        consigneePhone: y.ConsigneeMobileNumber,
                        consigneeEmail: y.ConsigneeEmail,
                        destinationId: y.DestinationId,
                        pcs: y.Pieces,
                        serviceType: y.ServiceType,
                        weight: y.Weight,
                        productDetails: y.ProductDetails,
                        remarks: y.Remarks,
                        refNo: y.CustomerReferenceNumber,
                        codAmount: y.CODAmount,
                        isDRTV: y.DRTV.toUpperCase() == 'YES' ? true : false,
                        supplierName: y.SupplierName,
                        supplierAddress: y.SupplierAddress,
                        supplierLocationId: y.SupplierBranchId,
                        supplierPhone: y.SupplierPhone
                    }
                })
            };
            dispatch(setLoading({ data: true }));
            const rs = await bulkSave(d);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                alert("Bookings Saved");
                dispatch(setGrid({ data: [] }));
                dispatch(setGridStatus({ data: rs.data }));
            } else {
                alert(rs.msg);
            }
        }
    }

    useEffect(() => {
        dispatch(setGrid({ data: [] }));
    }, [data.subAccountId])

    return (
        <>
            <div className="row">
                <datalist id="dests">
                    {
                        dests.map((x, index) => <option key={index} value={x} />)
                    }
                </datalist>
                <div className="col-lg">
                    <label>Type</label>
                    <select className="form-select" value={data.isCod ? 1 : 0} onChange={(e) => {
                        const d = { ...data, isCod: e.target.value == 1, locationId: '', autoCN: null, subAccountId: '' };
                        dispatch(setData({ data: d }));
                        setLocations([]);
                    }}>
                        {
                            types.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} onChange={async (e) => {
                        const val = e.target.value;
                        const autoCn = e.target[e.target.selectedIndex].getAttribute('data-autocn');
                        const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                        const d = { ...data, subAccountId: val, locationId: '', autoCN: autoCn ? autoCn === 'true' : null, accountNo: accno };
                        dispatch(setData({ data: d }));
                        if (val) {
                            const locs = await getLocations(userInfo.id, accno)
                            if (locs)
                                setLocations(locs);
                        } else {
                            setLocations([]);
                        }
                    }}>
                        <option value="" data-autocn={null} data-accno="">Select Sub Account</option>
                        {
                            subaccounts.filter(x => x.isCod == data.isCod).map((x, index) => <option key={index} value={x.id} data-autocn={x.autoCN} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Locations</label>
                    <select className="form-select" value={data.locationId} onChange={(e) => updateData('locationId', e.target.value)}>
                        <option value="">Select Location</option>
                        {
                            locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>File</label>
                    <input
                        type='file'
                        ref={fileRef}
                        className='form-control'
                        onChange={(e) => {
                            dispatch(setFileName({ data: e.target.files.length > 0 ? e.target.files[0].name : '' }))
                            dispatch(setFileLen({ data: e.target.files.length }))
                        }}
                    />
                </div>
                <div className="col-lg">
                    <a href="Sample.xlsx" download className="btn btn-sm btn-primary badge-orange" style={{ marginTop: '1.5rem' }}>Excel Sample</a>
                </div>
            </div>
            <div className="row">
                <div className="col-lg" style={{ textAlign: 'right' }}>
                    <button type="button" className="btn btn-primary" style={{ marginTop: '1.5rem' }} disabled={fileLen === 0} onClick={onUpload}>Upload</button>
                    <button type="button" className="btn btn-primary" style={{ marginTop: '1.5rem', marginLeft: 2 }} disabled={grid.length <= 0} onClick={onSave}>Save</button>
                </div>
            </div>
        </>
    )
}

export default Form;
